export const getExpertiseBorderColor = (value: string | undefined): string => {
  if (!value) return '';

  const lowerCaseValue = value.toLocaleLowerCase();

  if (lowerCaseValue === 'sorunsuz') {
    return 'green.500';
  }
  if (lowerCaseValue === 'servis kontrol') {
    return 'yellow.500';
  }
  if (lowerCaseValue === 'donanim yok') {
    return 'blue.500';
  }
  if (lowerCaseValue === 'hasarli') {
    return 'red.500';
  }
  if (lowerCaseValue === 'deforme') {
    return 'gray.800';
  }
  if (lowerCaseValue === 'acil kontrol') {
    return 'red.500';
  }
  return '';
};

export const getExpertiseBackgroundColor = (value: string | undefined): { bg: string; color: string } => {
  if (!value) return { bg: '', color: '' };

  const lowerCaseValue = value.toLocaleLowerCase();

  if (lowerCaseValue === 'sorunsuz') {
    return { bg: 'green.500', color: 'white' };
  }
  if (lowerCaseValue === 'donanim yok') {
    return { bg: 'black', color: 'white' };
  }
  if (lowerCaseValue === 'hasarli') {
    return { bg: 'red.500', color: 'white' };
  }
  if (lowerCaseValue === 'deforme') {
    return { bg: 'red.500', color: 'white' };
  }
  if (lowerCaseValue === 'acil kontrol') {
    return { bg: 'red.500', color: 'white' };
  }
  if (lowerCaseValue === 'servis kontrol') {
    return { bg: 'yellow.500', color: 'white' };
  }
  return { bg: 'chakra-body-bg', color: 'chakra-body-text' };
};
